module.exports = "<section class=\"t3-copyright\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-md-12 copyright \">\n        <small>\n          <strong>© 2007-{{ year }} Syncplicity LLC   |   All Rights Reserved</strong>\n        </small>\n      </div>\n      </div>\n  </div>\n</section>"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 20
// module chunks = 0